// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-input {
  position: relative;
  width: 100%;
  padding: 2em;
  border: 1px solid #777776;
  border-radius: 1em;
  height: 10em;
  display: flex;
  justify-content: center;
  align-items: center;
}
.file-input-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
}
.file-input-title {
  font-weight: bold;
}
.file-input-info {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  display: block;
  width: 40%;
  position: absolute;
  bottom: 0.4em;
}
.file-input input {
  cursor: pointer;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.file-input-error {
  border: 1px solid #dc3545;
}

.file-input-info-error {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.file-download {
  position: absolute;
  top: 0.5em;
  right: 2em;
  cursor: pointer;
  z-index: 10;
}

.file-delete {
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  cursor: pointer;
  z-index: 10;
}

.image-preview {
  width: 12em;
  height: 6em;
  border-radius: 0.5em;
  object-fit: cover;
}

.file-preview {
  height: 6em;
}

.file-hide {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/fileInput/file-input.scss","webpack://./src/sass/globals/mixins.scss"],"names":[],"mappings":"AAGA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;ECRA,aAAA;EACA,uBDSc;ECRd,mBDQsB;AADvB;AAGC;ECNA,aAAA;EACA,sBAAA;EACA,uBDKqB;ECJrB,mBDI6B;EAC5B,UAAA;AAEF;AACC;EACC,iBAAA;AACF;AAEC;EACC,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;AAAF;AAGC;EACC,eAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AADF;;AAKA;EACC,yBAAA;AAFD;;AAKA;EACC,mBAAA;EACA,kBAAA;EACA,cAAA;AAFD;;AAKA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;AAFD;;AAKA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAFD;;AAKA;EACC,WAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;AAFD;;AAKA;EACC,WAAA;AAFD;;AAKA;EACC,aAAA;AAFD","sourcesContent":["@import '../../sass/globals/globals.scss';\n@import '../../sass/globals/mixins.scss';\n\n.file-input {\n\tposition: relative;\n\twidth: 100%;\n\tpadding: 2em;\n\tborder: 1px solid $dark-grey;\n\tborder-radius: 1em;\n\theight: 10em;\n\n\t@include flex(center, center);\n\n\t&-label {\n\t\t@include flexColumn(center, center);\n\t\twidth: 80%;\n\t}\n\n\t&-title {\n\t\tfont-weight: bold;\n\t}\n\n\t&-info {\n\t\toverflow: hidden;\n\t\twhite-space: nowrap;\n\t\ttext-overflow: ellipsis;\n\t\ttext-align: center;\n\t\tdisplay: block;\n\t\twidth: 40%;\n\t\tposition: absolute;\n\t\tbottom: 0.4em;\n\t}\n\n\t& input {\n\t\tcursor: pointer;\n\t\topacity: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n}\n\n.file-input-error {\n\tborder: 1px solid #dc3545;\n}\n\n.file-input-info-error {\n\tmargin-top: 0.25rem;\n\tfont-size: 0.875em;\n\tcolor: #dc3545;\n}\n\n.file-download {\n\tposition: absolute;\n\ttop: 0.5em;\n\tright: 2em;\n\tcursor: pointer;\n\tz-index: 10;\n}\n\n.file-delete {\n\tposition: absolute;\n\ttop: 0.5em;\n\tright: 0.5em;\n\tcursor: pointer;\n\tz-index: 10;\n}\n\n.image-preview {\n\twidth: 12em;\n\theight: 6em;\n\tborder-radius: .5em;\n\tobject-fit: cover;\n}\n\n.file-preview {\n\theight: 6em;\n}\n\n.file-hide {\n\tdisplay: none;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
